import { AsyncThunk, AsyncThunkPayloadCreator, createAsyncThunk, ThunkAction } from '@reduxjs/toolkit'
import { AnyAction } from 'redux'
import type { ConsumerAppDispatch, ConsumerAppState } from './store'
import { HttpService } from '@afterpaytouch/portal-api'
import { HttpService as TopazHttpService } from '@afterpaytouch/topaz-api'
import { HttpService as ShopHttpService } from '@afterpaytouch/shop-api'
import { isPortalAxiosError, PortalApiError } from '../model'

export interface ConsumerThunkConfig {
  state: ConsumerAppState
  dispatch: ConsumerAppDispatch
  extra: {
    portalApi: () => HttpService
    topaz: () => TopazHttpService
    shop: () => ShopHttpService
  }
}

export interface PortalThunkConfig extends ConsumerThunkConfig {
  rejectValue: PortalApiError
}

export type AsyncAction<T> = ThunkAction<Promise<T>, ConsumerAppState, any, AnyAction>

export type PortalThunk<Request, Response> = AsyncThunk<Response, Request, PortalThunkConfig>

export const portalAction = <Request, Response>(
  name: string,
  creator: AsyncThunkPayloadCreator<Response, Request, PortalThunkConfig>
): PortalThunk<Request, Response> =>
  // @ts-ignore: OPERATION BLEED STOPPER
  createAsyncThunk<Response, Request, PortalThunkConfig>(name, async (args, thunk) => {
    try {
      return await creator(args, thunk)
    } catch (e) {
      if (isPortalAxiosError(e)) {
        // @ts-ignore: OPERATION BLEED STOPPER
        return thunk.rejectWithValue(e.response.data)
      } else {
        throw e
      }
    }
  })
